<template>
    <div class="gift-home">
        <gift-form
                :is-user-signed-in="isUserSignedIn"
                :userEmail="userEmail"
                v-bind:numRecipients.sync="numRecipients"
                v-bind:amount.sync="amount"
                v-on:validated="onFormValidated"
                ref="giftForm"
        />

        <div class="gift-btn" :class="!amount || !amount > 1 ? 'gift-btn-disabled' : ''" @click="validateInput()">
            Gift {{ formatPrice(totalAmount, true) }}
            <span v-if="numRecipients > 1">({{ formatPrice(amount, true) }} each)</span>
        </div>

        <modal :show-close-btn="showModalCloseBtn"
               :slide="true"
               :url-navigated-on-close="purchased ? '/gifts/new' : null"
               :reload-on-close="purchased"
               ref="modal">

            <div slot="header">
                <p class="gift-modal-heading">{{ modalHeading }}</p>
<!--                <p v-if="!creditCardLastDigits && !purchased" class="gift-modal-subheading">or <span @click="goToLoginStep"><strong>log in</strong></span></p>-->
            </div>

            <slot slot-scope="modal">
               <gift-modal-confirmation v-if="!purchased"
                       :gift-data="giftData"
                       :userName="userName"
                       :userEmail="userEmail"
                       :credit-card-last-digits="creditCardLastDigits"
                       :credit-balance="creditBalance"
                       :stripe-publishable-key="stripePublishableKey"
                       v-on:processingOrder="showModalCloseBtn = false"
                       v-on:error="showModalCloseBtn = true"
                       v-on:purchased="onOrderComplete"
               />
               <gift-modal-after-purchase v-else
                       :gift-reward-amount-cents="giftRewardAmountCents"
                       :is-user-signed-in="isUserSignedIn"
               />

            </slot>
        </modal>
    </div>
</template>

<script>
    import GiftForm from './gift-form-home.vue'
    import GiftModalConfirmation from './gift-modal-confirmation.vue'
    import GiftModalAfterPurchase from './gift-modal-after-purchase.vue'
    import Modal from '../../home/modal-home.vue';
    import CommonMixin from '../../../mixins/common-mixin'
    import GaMixin from '../../../mixins/google-analytics-mixin'

    export default {
        components: {
            GiftForm,
            GiftModalConfirmation,
            GiftModalAfterPurchase,
            Modal
        },
        props: {
            isUserSignedIn: Boolean,
            userName: String,
            userEmail: String,
            creditCardLastDigits: String,
            creditBalance: Number,
            stripePublishableKey: String
        },
        mixins: [
            CommonMixin,
            GaMixin
        ],
        data: function () {
            return {
                amount: 0,
                numRecipients: 1,
                giftData: {},
                purchased: false,
                giftRewardAmountCents: undefined,
                showModalCloseBtn: true
            }
        },
        methods: {
            validateInput() {
                this.$refs.giftForm.validate();
            },
            onFormValidated(giftData) {
                this.purchased = false;
                this.giftData = giftData;
                this.$refs.modal.show();
            },
            onOrderComplete(giftRewardAmountCents) {
                this.purchased =true;
                this.giftRewardAmountCents = giftRewardAmountCents;
                this.sendOrderEvent('Gift Credit', this.amount);
                this.showModalCloseBtn = true;
            }
        },
        computed: {
            totalAmount: function() {
                return this.amount * this.numRecipients;
            },
            modalHeading: function() {
                return this.purchased ? 'Your gift is on it\'s way!' : 'Confirmation';
            }
        },
        watch: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/variables_home";
    @import "../../../styles/common_home";

    .gift-home {
        padding: 3rem 0;
        margin-bottom: 2rem;
        text-align: center;
    }
    .gift-btn {
        @extend .btn-green-lg;
        line-height: 4rem;
        margin: auto;
    }
    .gift-btn-disabled {
        background: #110;
        opacity: .5;
    }
    .gift-modal-heading {
        margin: 0;
        font-size: 20px;
    }
    .gift-modal-subheading {
        margin: 0.5rem 0 0 0;
    }

    @media only screen and (max-width: $max-mobile-width) {
        .gift-home {
            padding-top: 0;
        }
    }
</style>
